export const convertStorageLanguageToText = (language: string): string => {
  switch (language) {
    case 'es-ES':
      return 'SPANISH';
    case 'es':
      return 'SPANISH';
    case 'en':
      return 'ENGLISH';
    case 'cat':
      return 'CATALAN';
    case 'pt':
      return 'PORTUGUESE';
    default:
      return 'SPANISH';
  }
};
